import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Platform } from '@ionic/angular';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AddressBase } from 'src/app/_interfaces/address';
import { ContentQuickSearch } from 'src/app/_interfaces/ContentQuickSearch';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { TicketBase } from 'src/app/_interfaces/ticket';
import { CrmDetailPagePage } from 'src/app/_pages/crm-detail-page/crm-detail-page.page';
import { TicketDetailPagePage } from 'src/app/_pages/ticket-detail-page/ticket-detail-page.page';
import { CrmService } from 'src/app/_provider/crm.service';
import { DarkmodeService } from 'src/app/_provider/darkmode.service';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { GeneralService } from 'src/app/_provider/general.service';
import { QuickSearchService } from 'src/app/_provider/quick-search.service';
import { StorageService } from 'src/app/_provider/storage.service';
import { TicketEmployee} from 'src/app/_provider/tickets/ticket.service';

const QUICKSEEARCH_STORAGE: string = "QuickSearchElements"

@Component({
    selector: 'app-quick-search',
    templateUrl: './quick-search.component.html',
    styleUrls: ['./quick-search.component.scss'],
    standalone: false
})
export class QuickSearchComponent implements OnInit {

  public searchText: string = ""
  public isLoading: boolean = false
  public recentlySearched: string[] = []
  public tickets: TicketBase[] = []
  public crms: AddressBase[] = []
  public content: ContentQuickSearch[] = []

  public isMac: boolean = false

  @ViewChild("search", {static: true}) private searchInput: ElementRef

  constructor(
    public quickSearchSrv: QuickSearchService,
    private storageSrv: StorageService,
    private ticketSrv: TicketEmployee.TicketService,
    private crmSrv: CrmService,
    private feedback: FeedbackService,
    private generalSrv: GeneralService,
    public darkmode: DarkmodeService,
    private platform: Platform,
    private deviceInformation: DeviceDetectorService,
  ) { }

  async ngOnInit() {
    this.searchInput.nativeElement.focus()
    await this.setRecentlySearched()
    this.isMac = this.deviceInformation.os == "Mac"
    
  }


  private saveRecentTimer
  private searchTimeout
  public searchTickets(event?: KeyboardEvent){

    //Öffnen bei Enter wenn nur ein Item da ist
    if(event){
      if(event.key == "Escape") this.closeQuickSearch()
      if(event.key == "Enter"){
        if(this.crms.length == 1 && this.content.length == 0 && this.tickets.length == 0) this.openCrm(this.crms[0])
        if(this.crms.length == 0 && this.content.length == 1 && this.tickets.length == 0) this.openTicketContent(this.content[0])
        if(this.crms.length == 0 && this.content.length == 0 && this.tickets.length == 1) this.openTicket(this.tickets[0])
        return
      }
    }
    
    if(this.searchText == '') this.isLoading = false
    else this.isLoading = true
    
    clearTimeout(this.saveRecentTimer)
    clearTimeout(this.searchTimeout)
    if(this.searchText == ""){
      this.tickets = []
      this.crms = []
      this.content = []
      return
    }

    this.searchTimeout = setTimeout(() => {
      //Abfragen ob leer. wenn ja dann raus aus funktion


      //Speichern von Suchtexten
      this.saveRecentTimer = setTimeout(async () => {
        if(!this.searchText) return
        await this.setRecentlySearched(4)
        this.recentlySearched.unshift(this.searchText)
        await this.storageSrv.save(QUICKSEEARCH_STORAGE, this.recentlySearched)
      }, 1000);


      //Tickets suchen
      this.ticketSrv.getAllTickets('all', "all", this.searchText, 3, 0, "newest", "all").then((response: HttpFunctionResult<TicketBase[]>)=>{
        this.isLoading = false
        if(!response.success) return
        this.tickets = response.data
      })

      //CRM suchen
      this.crmSrv.getBasicCrmList(this.searchText, 3, 0).then((response: HttpFunctionResult<AddressBase[]>)=>{
        this.isLoading = false
        if(!response.success) return
        this.crms = response.data
      })

      //Ticketinhalt durchsuchen
      this.ticketSrv.getAllTicketContentBySearch(this.searchText).then((response: HttpFunctionResult<ContentQuickSearch[]>)=>{
        this.isLoading = false
        if(!response.success) return
        this.content = response.data
      })

    }, 250);

  }

  private async setRecentlySearched(count: number = 5){
    let storageItems: string[] = await this.storageSrv.load(QUICKSEEARCH_STORAGE) as string[]
    this.recentlySearched = storageItems ? storageItems.slice(0, count) : []
  }

  public closeQuickSearch(){
    this.quickSearchSrv.closeQuickSearch()
  }

  public stopCloseEvent(event: Event){
    event.stopPropagation()
  }

  public recentlyItemClicked(searchText: string){
    this.searchText = searchText
    this.searchTickets()
  }

  public async deleteRecentlyItems(){
    await this.storageSrv.remove(QUICKSEEARCH_STORAGE)
    this.setRecentlySearched()
  }

  public async openTicket(ticket: TicketBase){
    this.quickSearchSrv.closeQuickSearch()
    this.generalSrv.setActiveTicket(ticket)
    this.quickSearchSrv.closeQuickSearch()
    // await this.feedback.openModal(TicketDetailPagePage, {isModal: true})
  }

  public async openCrm(crm: AddressBase){
    this.quickSearchSrv.closeQuickSearch()
    this.generalSrv.setActiveCrm(crm)
    await this.feedback.openModal<any>(CrmDetailPagePage, {isModal: true})
  }

  public async openTicketContent(content: ContentQuickSearch){
    this.quickSearchSrv.closeQuickSearch()
    this.generalSrv.setActiveTicket(content.ticket, content.workstepId)
    this.quickSearchSrv.closeQuickSearch()
    // await this.feedback.openModal(TicketDetailPagePage, {isModal: true, modelWorkstepId: content.workstepId})
  }

}
